<glxy-form-field>
  <glxy-label>
    {{ 'AI_ASSISTANT.SETTINGS.LEAD_CAPTURE.SELECT_FIELDS' | translate }}
  </glxy-label>
  <mat-chip-grid #chipGrid aria-label="Lead capture fields" [disabled]="disableConfigurableGoalFields()">
    @for (field of selectedFields(); track field.fieldName) {
      <mat-chip-row [removable]="!isDefaultField(field)" (removed)="removeField(field)" [disabled]="disableConfigurableGoalFields()">
        {{ field.fieldName }}
        @if (!isDefaultField(field)) {
          <button matChipRemove [attr.aria-label]="'Remove ' + field.fieldName">
            <mat-icon>cancel</mat-icon>
          </button>
        }
      </mat-chip-row>
    }
    <input
      #fieldInput
      placeholder="{{ 'AI_ASSISTANT.SETTINGS.LEAD_CAPTURE.ADD_FIELD_PLACEHOLDER' | translate }}"
      [formControl]="fieldSearchControl"
      [matChipInputFor]="chipGrid"
      [matAutocomplete]="auto"
      [disabled]="disableConfigurableGoalFields()"
    />
  </mat-chip-grid>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectField($event)">
    @for (field of filteredFields(); track field.fieldName) {
      <mat-option [value]="field">{{ field.fieldName }}</mat-option>
    }
  </mat-autocomplete>
  <glxy-hint>{{ 'AI_ASSISTANT.SETTINGS.LEAD_CAPTURE.FIELDS_HINT' | translate }}</glxy-hint>
</glxy-form-field>
